export default "/images/reddit.svg?a106ad19c5ab251e64845c72131cc181";